import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Link, useLocation } from 'react-router-dom';
import { SideNavSection } from './side-nav-section';
import { NavSkeleton } from './nav-skeleton';
import { Scrollbar } from '@components/admin/elements/scrollbar';
import { TenantLogo } from '@components/shared/branding/tenant-logo';

export const NavContent = ({ sections, loading = false }) => {
  const location = useLocation();

  return (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': {
          height: '100%',
        },
        '& .simplebar-scrollbar:before': {
          background: 'var(--nav-scrollbar-color)',
        },
      }}
    >
      <Stack sx={{ height: '100%' }}>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: "center",
            p: 3
          }}>
          <Box
            component={Link}
            to="/admin"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '64px',
              p: '4px',
              width: '100%',
              color: 'var(--nav-color)',
              textDecoration: 'none',
            }}
          >
            {/* Tenant logo when uploaded, else the Connexio wordmark. */}
            <TenantLogo
              height={40}
              maxWidth="100%"
              alt="Connexio"
              fallback={
                <Box sx={{ fontSize: '24px', fontWeight: 700, letterSpacing: '0.5px' }}>
                  CONNEXIO
                </Box>
              }
            />
          </Box>
        </Stack>
        <Stack
          component="nav"
          spacing={2}
          sx={{
            flexGrow: 1,
            px: 2,
          }}
        > 
          {/* While the feature menu is still fetching, show placeholder rows
              instead of an empty sidebar; swap in the real items once loaded. */}
          {loading ? (
            <NavSkeleton />
          ) : (
            <SideNavSection
              items={sections}
              pathname={location.pathname}
            />
          )}
        </Stack>
      </Stack>
    </Scrollbar>
  );
};

NavContent.propTypes = {
  sections: PropTypes.array,
  loading: PropTypes.bool,
};
